const links = new Set();
const DEFAULT_ROOT_MARGIN = '1600px 0px';

function applyStylesheet(link) {
  if (!(link instanceof HTMLLinkElement) || link.dataset.chDeferredApplied === 'true') return;

  link.dataset.chDeferredApplied = 'true';
  link.rel = 'stylesheet';
  link.removeAttribute('as');
  link.removeAttribute('fetchpriority');
}

function scheduleApply(link) {
  const run = () => applyStylesheet(link);

  if (document.readyState === 'complete') {
    const requestIdleCallback = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 1));
    requestIdleCallback(run, { timeout: 1200 });
    return;
  }

  window.addEventListener('load', run, { once: true });
}

function observeSection(link, selector) {
  const target = document.querySelector(selector);
  if (!target || !('IntersectionObserver' in window)) {
    scheduleApply(link);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      applyStylesheet(link);
    },
    { rootMargin: link.dataset.chDeferredRootMargin || DEFAULT_ROOT_MARGIN },
  );

  observer.observe(target);
}

function hydrateDeferredStylesheets(root = document) {
  root.querySelectorAll?.('link[data-ch-deferred-stylesheet]:not([data-ch-deferred-hydrated])').forEach((link) => {
    if (!(link instanceof HTMLLinkElement)) return;

    link.dataset.chDeferredHydrated = 'true';
    links.add(link);

    const selector = link.dataset.chDeferredSelector;
    if (selector) {
      observeSection(link, selector);
    } else {
      scheduleApply(link);
    }
  });
}

hydrateDeferredStylesheets();

document.addEventListener('shopify:section:load', (event) => {
  if (!(event.target instanceof Element)) return;
  hydrateDeferredStylesheets(event.target);
});
